/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import {client} from '../Client';
import { Form } from 'semantic-ui-react'
import {convertNullToEmptyString, arrayToCombo, arrayToComboAdd} from '../Helpers'
import Autocomplete from 'react-autocomplete'
import PropTypes from 'prop-types';
import '../styles/TestiEditDropdown.css'

class TestiEditDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            tipo: this.props.tipo,
            itemList: [],
            dropdownLoading: false,
        };
        this.onItemAddition = this.onItemAddition.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onLoading = this.onLoading.bind(this);
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    onLoading(value){
        this.setState({ dropdownLoading: value });
        if (this.props.onLoading !== undefined){
            this.props.onLoading(value)
        }
    }

    loadDropdown(){
        this.onLoading(true);
        client.loadTestiPerTipoList(this.state.tipo).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.onLoading(false);
                    this.setState({
                        error: null,
                        itemList: arrayToCombo(data, "idTesto", "valore", "valore")
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.onLoading(false);
                    this.setState({
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.onLoading(false);
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    onItemAddition = (value) => {
        if (value.length > this.props.maxlength){
            value = value.substring(0, this.props.maxlength);
        }
        this.onLoading(true);
        client.saveTestiPerTipo(
            this.state.tipo, value
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    data = convertNullToEmptyString(data);
                    //let fields = this.state.fields;
                    //fields.forma = data.valore;
                    this.onLoading(false);
                    this.setState({
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        itemList: arrayToComboAdd(this.state.itemList, data, 'idTesto', 'valore', 'valore')
                    }, () => {
                        this.props.onChange(undefined, {name: this.props.name, value: data.valore})
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else{
                this.onLoading(false);
                this.setState({
                    inError: true,
                    fieldErrors: {'Testo': 'errore salvataggio testo'},
                    fieldErrorsText: ["errore caricamento testo"],
                    errorTitle: "Errore imprevisto",
                });
            }
        }).catch((error) => {
            this.onLoading(false);
            this.setState({
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onChange(ev, {name, value}){
        if (value !== undefined && value.length <= this.props.maxlength)
        {
            this.props.onChange(ev, {name, value})
        }
        else {
            ev.preventDefault();
        }
    }

    onSearchChange(ev, value){
        if (value !== undefined && value.length > this.props.maxlength)
        {
            ev.preventDefault();
        }
    }

    componentWillMount() {
        this.loadDropdown();
    }

    componentWillReceiveProps(nextProps){

    }

    OnMenuShow(isOpen){
        this.setState({menuOpen: isOpen})
    }

    matchStateToTerm(item, value){
        return !value || item.text.toLowerCase().trim().includes(value.toLowerCase().trim());
    }

    render() {
        let inputProps = {name: this.props.name, contentEditable:"true", className:"search text", style:{display:"inline block"}};
        if (this.props.maxlength) {
            inputProps.maxLength = this.props.maxlength;
        }
        if (this.props.placeholder){
            inputProps.placeholder = this.props.placeholder;
        }
        let label = null;
        if (this.props.label){
            label = <label>{this.props.label}</label>
        }
        return (
            <Form.Field required={this.props.required}>
                {label}
                <Autocomplete
                    onMenuVisibilityChange={(isOpen) => this.OnMenuShow(isOpen)}
                    getItemValue={(item) => item.text}
                    autoHighlight={true}
                    value={this.props.value}
                    items={this.state.itemList}


                    renderMenu={(items, value, styles) => {

                        let addItem = (
                            <div key="-1" role="option"
                                aria-checked="false" aria-selected="false"
                                className="item" style={{cursor: "auto"}}
                            >
                                <span className="text">{this.props.additionLabel ? this.props.additionLabel : 'Salva nuovo valore:'}<b>{value} </b></span>
                                &nbsp;<a className="ui blue pointer" onClick={() => this.onItemAddition(value)}><i className="save icon"></i> Salva</a>
                            </div>
                        )
                        let found = (items.find((item) => {
                            let text = item.props.children.props.children;
                            text = text ? text.trim():text;
                            return text === value.trim()
                        })) !== undefined;

                        if (items.length > 0 && !found)
                        {
                            return (
                                <div role="listbox" className="menu transition visible">
                                    {addItem}
                                    {items}
                                </div>)
                        }
                        if (items.length > 0 )
                        {
                            return (
                                <div role="listbox" className="menu transition visible">
                                    {items}
                                </div>)
                        }
                        else {
                            return (
                                <div role="listbox" className="menu transition visible" >
                                    {addItem}
                                </div>
                            );
                        }
                    }}
                    renderItem={(item, isHighlighted) =>{
                        let classname="item";
                        let styleselected = {pointerEvents: "all"};
                        if (isHighlighted) {
                            classname = "selected " + classname;
                            styleselected = {pointerEvents: "all", backgroundColor: "#BBB"};
                        }
                        if (item.text.trim() === this.props.value.trim()) {
                            classname = "active " + classname;
                        }

                        return <div key={item.key} role="option" aria-checked="false" aria-selected="false" className={classname} style={styleselected}>
                            <span className="text">{item.text}</span>
                        </div>

                        }
                    }
                    shouldItemRender={(item, value) => this.matchStateToTerm(item, value)}
                    wrapperStyle={{display:"inline block"}}
                    wrapperProps={this.state.menuOpen ? {className:"ui active visible fluid search selection dropdown"} : {className:"ui fluid dropdown"}} //
                    inputProps={inputProps}

                    onChange={(e) => {this.onChange(e, {name:this.props.name, value:e.target.value})} }
                    onSelect={(val, item) => {this.onChange(undefined, {name:this.props.name, value:val})}}
                />
            </Form.Field>
        )
    }
}

TestiEditDropdown.PropTypes = {
    tipo: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    maxlength: PropTypes.number.isRequired,
    required: PropTypes.number.isRequired,
    additionLabel: PropTypes.string.isRequired,
    value: PropTypes.string,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onLoading: PropTypes.func.isRequired,
};

TestiEditDropdown.defaultProps = {
    tipo: 'MFORM',
    maxlength: 255,
    required: false,
    placeholder: ''
};

TestiEditDropdown.contextTypes = {
    router: PropTypes.object
}

export default TestiEditDropdown;



/** WEBPACK FOOTER **
 ** ./src/components/TestiEditDropdown.jsx
 **/